
import  axios  from 'axios';


export const LOAD_ACCOUNT_DATA = 'account/LOAD_ACCOUNT_DATA';
export const DELETE_A_ACCOUNT = 'account/DELETE_A_ACCOUNT';
export const SAVE_A_ACCOUNT = 'account/SAVE_A_ACCOUNT';
export const UPDATE_A_ACCOUNT = 'account/UPDATE_A_ACCOUNT';


export function loadAccountDataInStore(argAccountDataArray) {
    return {
        type: LOAD_ACCOUNT_DATA,
        accountsData:argAccountDataArray
    }
}
export function deleteAAccountDataInStore(argDeleteResponse, argErrorMsg) {
    return {
        type: DELETE_A_ACCOUNT,
        deleteAccountResponse:argDeleteResponse,
        errorMsg:argErrorMsg
    }
}

export function saveAAccountDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: SAVE_A_ACCOUNT,
        saveAccountResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

export function updateAAccountDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: UPDATE_A_ACCOUNT,
        updateAccountResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

/********************* End of InStore calls **************************/

//****************************************
//Below is for update a Stream
//****************************************
export function updateAAccount(argURL, argCamera) {
    return (dispatch, getState) => {

        updateAAccountOnServer(argURL, argCamera).then(function(saveResponse){

            dispatch(saveAAccountDataInStore(saveResponse, {}));

        }, function(err){
            console.log("I had an error saving a account" + err.response.data);
            dispatch(saveAAccountDataInStore({}, err.response.data));
        });
    }//end of return
}


function updateAAccountOnServer( argURL, argCamera){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPutsForUpdateAAccount(argURL, argCamera)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on saving a accounts " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPutsForUpdateAAccount(argURL, argCamera ){
    /*
     I build something like this :
     http://localhost:4567/accounts
     */

    let baseUrl = argURL+"bankaccounts";
    console.log(" on posting a accounties the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.put(baseUrl,argCamera ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for save a Stream
//****************************************
export function saveAAccount(argURL, argCamera) {
    return (dispatch, getState) => {

        saveAAccountOnServer(argURL, argCamera).then(function(saveResponse){

            dispatch(saveAAccountDataInStore(saveResponse, {}));

        }, function(err){
            console.log("I had an error saving a account" + err.response.data);
            dispatch(saveAAccountDataInStore({}, err.response.data));
        });
    }//end of return
}


function saveAAccountOnServer( argURL, argCamera){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPostsForSaveAAccount(argURL, argCamera)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on saving a accounts " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPostsForSaveAAccount(argURL, argCamera ){
    /*
     I build something like this :
     http://localhost:4567/accounts
     */

    let baseUrl = argURL+"bankaccounts";
    console.log(" on posting a accounties the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.post(baseUrl,argCamera ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for delete a account
//****************************************
export function deleteAAccount(argURL, argCameraId) {
    return (dispatch, getState) => {

        deleteAAccountOnServer(argURL, argCameraId).then(function(deleteResponse){

            dispatch(deleteAAccountDataInStore(deleteResponse, null));

        }, function(err){
            console.log("I had an error gettting Stream Data2" + err);
            dispatch(deleteAAccountDataInStore({}, err));
        });
    }//end of return
}


function deleteAAccountOnServer( argURL, argStreamId){

    var returnPromise = new Promise(function(resolve, reject){



        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfDeletesForDeleteAAccount(argURL, argStreamId)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on deleteing a account " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfDeletesForDeleteAAccount(argURL, argStreamId ){
    /*
     I build something like this :
     http://localhost:4567/cameras
     */

    let baseUrl = argURL+"bankaccounts"+"/"+argStreamId;
    console.log(" on deleteing a account the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.delete(baseUrl));
    }
    return arrayOfGets;
}


//Get list of accounts

export function loadAccountsData(argURL) {
    return (dispatch, getState) => {

        getListOfAccounts(argURL).then(function(accountsList){

            dispatch(loadAccountDataInStore(accountsList));

    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}

function getArrayOfGetsForListOfAccounts(argURL ){
    /*
     I build something like this :
     http://localhost:4567/account
     */

    let baseUrl = argURL+"bankaccounts";
    console.log(" on getting list of Accounts  the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl));
    }
    return arrayOfGets;
}

function getListOfAccounts( argURL){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForListOfAccounts(argURL)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on getting list of Accounts " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}


function getAccountDataFromRemoteServer( argURL, argAccountsList  ){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if(argAccountsList != null){

            axios.all(getArrayOfGets(argURL, argAccountsList )).then(function(responses){
                resolve(responses);

            }, function(err) {
                console.log("Farshid some error occured " + err.message);
                reject(err);
            });
        }
    });

    return returnPromise;
}

function getArrayOfGets(argURL, argFarmsList ){

    //let baseUrl =  "http://innovasea-app-dev-1.eastus.cloudapp.azure.com:4567/METRIC_VALUES?";
    let baseUrl = argURL;

    /*

     I need to build something like this :

     http://innovasea-app-dev-1.eastus.cloudapp.azure.com:4567/GRAPHS/farm_summary?farmId=f1
     */

    var arrayOfGets = [];
    if(argFarmsList != null) {
        for (var i = 0; i < argFarmsList.length; i++) {
                let responseData = argFarmsList[i];
                //let responseData = singleResponse.data;
                //if((argMetricList[i].checked != null) && (argMetricList[i].checked == true) ) {
                let tempURl = baseUrl + "GRAPHS" + "/farm_summary?farmId=" + responseData.id;
                console.log("Farshid the Account DATA URL is =" + tempURl);
                arrayOfGets.push(axios.get(tempURl));

            //}
        }
    }
    return arrayOfGets;


}

/*
export function loadAccountData(argURL) {
    return (dispatch, getState) => {


        var arrayOfAccountData=[];
        getListOfAccounts(argURL).then(function(accountsList){

            for(var z=0; z<accountsList.length; z++){

                let singleResponse = accountsList[z];
                let responseData = singleResponse.data;
                getAccountDataFromRemoteServer(argURL,responseData ).then(function (farmsData){
                    for(var i=0; i<farmsData.length; i++) {
                        arrayOfAccountData.push(farmsData[i].data);
                    }
                    dispatch(loadAccountDataInStore(arrayOfAccountData));

                }, function (err){
                    console.log("I had an error gettting Farms Data3333" + err);
                });

            }
    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}
 */